import React from "react";
import Link from "next/link";
import styles from "./gallery_top_section.module.scss";
import { upperFirstLetter } from "@unisearch/helpers";

export const GalleryTopSection = ({ tagsList, format }) => {
  let name = "";
  if (format === "gallery") {
    name = "image";
  } else {
    name = format;
  }

  return (
    <section className={styles.blog_hero_simple}>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.breadcrumbs}>
            <Link legacyBehavior href="/news">
              <a>Home ›</a>
            </Link>
            <span>{upperFirstLetter(name)}</span>
          </div>
          <h2 className={styles.title}>{upperFirstLetter(name)} Gallery</h2>

          {tagsList && tagsList?.length > 0 && (
            <ul className={styles.gallery_tags}>
              {tagsList &&
                tagsList?.length > 0 &&
                tagsList?.map((tag, i) => {
                  return (
                    <li key={`${i}gallery`}>
                      <Link
                        legacyBehavior
                        href={`/news/${format}/tag?limit=8&page=1&tag=${tag?.value}&newsFormat=${format}`}
                      >
                        <a>{tag?.label}</a>
                      </Link>
                    </li>
                  );
                })}
            </ul>
          )}
        </div>
      </div>
    </section>
  );
};

export default GalleryTopSection;
